import { NAME_SPACE } from './config';
import stepsCarousel from './StepsCarousel.vue';

export default {
    name: NAME_SPACE,
    components: {
        'steps-carousel': stepsCarousel,
    },
};
